import { useEffect } from "react";
import { useFormik } from "formik";
import { getNanoId } from "utils";
import { SketchEditor as View, Sketch } from "ui-components";

import {
	useSetActive,
	useAddSketch,
	useSetSelectSketch,
	useSetSketchGeojson,
	useSetDrawingMode,
	useSketchGeojson,
} from "~map-view/states/sketch";

export const SketchCreate = (props) => {
	const setSketchGeojson = useSetSketchGeojson();
	const sketchGeojson = useSketchGeojson();
	const setActive = useSetActive();
	const addSketch = useAddSketch();
	const setSelectSketch = useSetSelectSketch();
	const setDrawingMode = useSetDrawingMode();

	const form = useFormik<Sketch>({
		initialValues: {
			title: "",
			description: "",
			editable: true,
			id: getNanoId(),
		},
		onSubmit: (values, helpers) => {
			setDrawingMode("close");
			if (values.id === "") values.id = getNanoId();
			addSketch({ ...values, geojson: JSON.stringify(sketchGeojson) });
			setActive("Sketches");
			setSketchGeojson(null);
			helpers.resetForm();
		},
	});

	useEffect(() => {
		void form.setValues({
			title: "",
			description: "",
			editable: true,
			id: getNanoId(),
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSketchModeChange = (mode) => {
		setDrawingMode(mode);
		setSelectSketch(form.values);
	};

	const handleCancel = () => {
		setActive("Sketches");
	};

	if (props.active === "Create Sketch") {
		return (
			<View
				form={form}
				onCancel={handleCancel}
				onSketchModeChange={handleSketchModeChange}
			/>
		);
	}
	return null;
};
